<template>
  <div class="action-bar">
    <div class="action-bar-item">
      <DatePicker
        v-if="filterConfig.datepicker && !hideDatePicker"
        :disabled="isLoading || disabledFilters"
        :is-loading="isLoading"
        @filters-tracking-event="handleTrackingEvent"
      />
    </div>
    <EmployerBrandTemplateSwitch v-if="!isLoading" />
    <div
      v-if="!hideFilters && filterConfig.subMenuType"
      class="action-bar-item"
    >
      <v-skeleton-loader
        v-if="isLoading"
        type="button"
        height="40px"
        width="150px"
      />
      <FilterSubMenu
        v-else
        class="sorting-dropdown"
        :type="filterConfig.subMenuType"
        :chip-height="40"
        @filters-tracking-event="handleTrackingEvent"
      />
    </div>
    <InsightsSubmenu
      class="ml-2"
      :shareable="pageIsShareable"
      :disable-filters="disabledFilters || isLoading"
    />
  </div>
</template>

<script setup>
import InsightsSubmenu from '@/components/insights/table/InsightsSubmenu.vue';
import FilterSubMenu from '@/components/filter/filterMenu/FilterSubMenu.vue';
import DatePicker from '@/components/filter/dateFilters/DatePicker.vue';
import { useTracking } from '@/stores/tracking/tracking';
import EmployerBrandTemplateSwitch from '@/components/insights/ActionableInsight/EmployerBrandTemplateSwitch.vue';

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  pageIsShareable: {
    type: Boolean,
    default: false,
  },
  disabledFilters: {
    type: Boolean,
    default: false,
  },
  hideFilters: {
    type: Boolean,
    default: false,
  },
  hideDatePicker: {
    type: Boolean,
    default: false,
  },
  filterConfig: {
    type: Object,
    default: () => ({}),
  },
});

// Methods
const handleTrackingEvent = ({ action, args }) => {
  useTracking()[action](args);
};
</script>

<style lang="less" scoped>
.action-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 16px;

  .action-bar-item {
    border-right: 1px solid @stroke-default;
    padding-right: 16px;
  }

  .action-bar-item .sorting-dropdown {
    :deep(.v-chip--label) {
      background: @bg-default;
      border: 1px solid @stroke-default;
      border-radius: 8px;
    }
  }
}

.v-skeleton-loader {
  background: transparent;
  border-radius: 0px;

  :deep(.v-skeleton-loader__button) {
    margin: 0;
    border-radius: 8px;
    max-width: 150px;
  }
}
</style>
